import Link from "components/shared/Link";
import { Context } from "Context";
import { useContext, useEffect } from "react";
import { isCurrentPathPresent } from "utils";

const StickyCta = ({ setShowStickyCta, showStickyCta }) => {
	const {
		headerData: { chrome },
	} = useContext(Context);

	useEffect(() => {
		setShowStickyCta(
			chrome?.ticketsCta && !isCurrentPathPresent(chrome.excludeTicketCtaPage)
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [chrome]);

	if (!showStickyCta) {
		return null;
	}

	return (
		<Link
			{...chrome.ticketsCta}
			className="syndicated-navigation__nav__sticky-cta"
		/>
	);
};

export default StickyCta;
